export const POST_REQUEST = 'forgotPassword/POST_REQUEST'
export const POST_SUCCESS = 'forgotPassword/POST_SUCCESS'
export const POST_FAILURE = 'forgotPassword/POST_FAILURE'